<script>
import CalendarReservations from "@/components/Calendars/CalendarReservations.vue";
import moment from "moment";
import {mapGetters} from "vuex";
import RegularReservationModal from "@/views/pages/project/work_reserves/modals/RegularReservationModal";
import datetime from "@/mixins/datetime";
import router from "@/mixins/router";
import systemCode from "@/mixins/systemCode";
import DatePicker from "vue2-datepicker";
import constants from '@/configs/constant';
import apiEndpoints from "@/services/apiEndpoints";

const REGULARLY_RESERVATION_WEEKLY = 1;
const REGULARLY_RESERVATION_BIWEEKLY = 2;
const REGULARLY_RESERVATION_MONTHLY = 3;
const DAY_OF_TIME_ZONE_AM = 1;

const REGULAR_RESERVATION = "regular_reservation";
const RESERVATION_DATES = "reservation_dates";

export default {
  components: {
    CalendarReservations,
    RegularReservationModal,
    DatePicker
  },
  mixins: [datetime, router, systemCode],
  props: ["reservation_dates_by_work_reservation", "work_reservation", "disabled", "car_estimates_by_work_reservation", "zz_work_order_type_id"],
  data() {
    return {
      isLoading: true,
      dataSelected: {
        reservation_dates_by_work_reservation: [],
        zz_regularly_reservation_interval_id: null,
        zz_day_of_time_zone_id: null,
        regularly_reservation_start_date: "",
        regularly_reservation_end_date: "",
        regularly_reservation_date_of_month: "",
        regularly_reservation_day_of_week: [],
        schedule_type: this.work_reservation.schedule_type
      },
      scheduleType: {
        "reservation_dates": RESERVATION_DATES,
        "regular_reservation": REGULAR_RESERVATION
      },
      events: [],
      msgError: {
        regularly_reservation_start_date: "",
        regularly_reservation_end_date: ""
      }
    };
  },
  watch: {
    work_reservation: {
      immediate: true,
      handler: function (val) {
        this.dataSelected.zz_regularly_reservation_interval_id = this.work_reservation.zz_regularly_reservation_interval_id
        this.dataSelected.regularly_reservation_start_date = this.work_reservation.regularly_reservation_start_date
        this.dataSelected.regularly_reservation_end_date = this.work_reservation.regularly_reservation_end_date
        this.dataSelected.regularly_reservation_date_of_month = this.work_reservation.regularly_reservation_date_of_month
        this.dataSelected.regularly_reservation_day_of_week = this.work_reservation.regularly_reservation_day_of_week
        this.dataSelected.zz_day_of_time_zone_id = this.work_reservation.zz_day_of_time_zone_id
        this.dataSelected.schedule_type = this.work_reservation.schedule_type
      },
    },
    'dataSelected.regularly_reservation_start_date': {
      immediate: true,
      handler: function (val) {
        if (!val || !this.dataSelected.regularly_reservation_end_date) return;

        const startDate = this.$moment(val);
        const endDate = this.$moment(this.dataSelected.regularly_reservation_end_date);
        if (endDate.isBefore(startDate)) {
          this.dataSelected.regularly_reservation_end_date = '';
        }
      },
    },
  },
  methods: {
    getData() {
      if (this.isLoading) {
        this.events = [];
        this.work_reservation.reservation_dates_by_work_reservation.forEach(item => {
          this.events.push(item);
        })
        this.isLoading = false
      }
    },
    onSelectedData(dataSelected) {
      this.dataSelected.reservation_dates_by_work_reservation = dataSelected
    },
    async updateValue() {
      let customDataSelected = {...this.dataSelected};
      if (customDataSelected.zz_regularly_reservation_interval_id != REGULARLY_RESERVATION_MONTHLY) {
        customDataSelected.regularly_reservation_date_of_month = '';
      }
      if (customDataSelected.zz_regularly_reservation_interval_id != REGULARLY_RESERVATION_WEEKLY && customDataSelected.zz_regularly_reservation_interval_id != REGULARLY_RESERVATION_BIWEEKLY) {
        customDataSelected.regularly_reservation_day_of_week = [];
      }

      const validatedData = await this.validationReservationType(customDataSelected);
      this.$emit('dataSelected', {
        ...customDataSelected,
        reservation_dates_by_work_reservation: validatedData
      });
      this.isLoading = true
      this.$bvModal.hide("calendar");
    },
    async validationReservationType(customDataSelected) {
      const {data, code, status} = await this.$http.post(apiEndpoints.reservation_dates_validation_type, {
        ...customDataSelected,
        car_estimates_by_work_reservation: this.car_estimates_by_work_reservation
      });

      if (status) {
        return data?.result?.dates || []
      }

      return []
    },
    disabledDateForStartDate: function (date) {
      let maxDate = new Date(this.maxDate);
      // console.log(maxDate);
      return date.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0) || maxDate.setHours(0, 0, 0, 0) < date.setHours(0, 0, 0, 0);
    },
    resetForm() {
      this.$refs.observer.reset();
    },
    onHiddenModal() {
      this.isLoading = true;
      this.$bvModal.hide("calendar");
    },
    changeStartDate() {
      let that = this
      setTimeout(function(scope) {
        if (! that.dataSelected.regularly_reservation_start_date) {
          that.msgError.regularly_reservation_start_date = "開始年月日は必須項目です"
        } else {
          that.msgError.regularly_reservation_start_date = ""
        }
      }, 300);

    },
    changeEndDate() {
      let that = this
      setTimeout(function(scope) {
        if (! that.dataSelected.regularly_reservation_end_date) {
          that.msgError.regularly_reservation_end_date = "終了年月日は必須項目です"
        } else {
          that.msgError.regularly_reservation_end_date = ""
        }
      }, 300);
    },
  },
  computed: {
    ...mapGetters("options", ["options_tables"]),
    selectScheduleType() {
      return [
        {
          text: "予約日選択",
          value: RESERVATION_DATES
        },
        {
          text: "定期予約",
          value: REGULAR_RESERVATION
        }
      ];
    },
    days_of_the_week() {
      return constants.DAY_OF_WEEKS;
    },
    isDateOfMonth() {
      return this.dataSelected.zz_regularly_reservation_interval_id == REGULARLY_RESERVATION_MONTHLY ? true : false;
    },
    isDateOfWeek() {
      return this.dataSelected.zz_regularly_reservation_interval_id == REGULARLY_RESERVATION_WEEKLY
      || this.dataSelected.zz_regularly_reservation_interval_id == REGULARLY_RESERVATION_BIWEEKLY ? true : false;
    },
    checkValidate() {
      if (this.dataSelected.schedule_type == RESERVATION_DATES) return true;
      let data = this.dataSelected;
      if (this.isDateOfMonth && (!data.regularly_reservation_date_of_month || data.regularly_reservation_date_of_month < 1 || data.regularly_reservation_date_of_month > 31)) return false;
      if (this.isDateOfWeek && !data.regularly_reservation_day_of_week.length) return false;
      if (!data.regularly_reservation_start_date) return false;
      if (!data.regularly_reservation_end_date) return false;
      if (!data.zz_regularly_reservation_interval_id) return false;
      if (!data.zz_day_of_time_zone_id) return false;

      return true;
    },
    isSelectRegularlyReservation() {
      return this.dataSelected.schedule_type === REGULAR_RESERVATION;
    },
    isSelectSpecificDates() {
      return this.dataSelected.schedule_type === RESERVATION_DATES;
    },
    maxReservationMonths() {
      return this.findMaxReservationMonths()?.system_code_value ?? 12;
    },
    maxDate() {
      return moment(this.addOrSubtractTimeFromDate(
        this.maxReservationMonths,
        "month",
        "add"
      )).format('YYYY-MM-DD');
    }
  }
};
</script>
<template>
  <div class="d-xl-flex mr-2">
    <button
      v-b-modal.calendar
      :disabled="disabled"
      class="btn btn-primary waves-effect waves-light"
    >
      <i class='fas fa-calendar-alt'></i> 予約日を登録する
    </button>
    <!-- modal area -->
    <b-modal
      size="lg"
      id="calendar"
      centered
      title-class="font-18"
      title="予約日の設定"
      hide-footer
      scrollable
      @shown="getData"
      @hidden="$emit('modalHidden', 'key_calendar')"
    >
      <b-row class="mt-4">
        <b-form-radio
          @change="resetForm"
          checked
          v-model="dataSelected.schedule_type"
          name="schedule-type"
          :value="selectScheduleType[0].value"
        >
          {{ selectScheduleType[0].text }}
        </b-form-radio>

        <CalendarReservations
          v-if="!isLoading && isSelectSpecificDates"
          :isCheckedEvent="true"
          :events="events"
          :start_date="dataSelected.regularly_reservation_start_date"
          :end_date="dataSelected.regularly_reservation_end_date"
          :validation-type="true"
          :car-estimates-by-work-reservation="car_estimates_by_work_reservation"
          ref="calendar_display_month"
          @onSelectedData="onSelectedData"
          class="reserve-calendar"
          :className="'reserve-calendar'"
        />
        <b-form-radio
          class="mt-4"
          v-model="dataSelected.schedule_type"
          name="schedule-type"
          :value="selectScheduleType[1].value"
          :disabled="zz_work_order_type_id == '06'"
        >
          {{ selectScheduleType[1].text }}
        </b-form-radio>
        <b-row class="mt-2" v-show="isSelectRegularlyReservation">
          <b-overlay
            :show="isLoading"
            rounded
            opacity="0.6"
            spinner-small
            spinner-variant="primary"
            class="d-inline-block"
          >
            <ValidationObserver v-slot="{ invalid }" ref='observer'>
              <b-row class="select-date">
                <b-col sm="1" style="width: 12.3%;" class="d-flex align-items-center">開始年月日</b-col>
                <b-col sm="4" style="width: 28.333333%;">
                    <div class="custom-datepicker gap-2">
                      <div class="input-control" :class="msgError.regularly_reservation_start_date ? 'invalid ': ''">
                        <date-picker
                          v-model="dataSelected.regularly_reservation_start_date"
                          lang="ja"
                          placeholder="YYYY-MM-DD"
                          format="YYYY-MM-DD"
                          value-type="YYYY-MM-DD"
                          position="left"
                          :disabled-date="disabledDateForStartDate"
                          @blur="changeStartDate"
                        ></date-picker>
                        <span>{{msgError.regularly_reservation_start_date}}</span>
                      </div>
                    </div>
                </b-col>
                <b-col cols="1" class="split text-center">
                  <span>～</span>
                </b-col>
                <b-col sm="5">
                    <div class="custom-datepicker gap-2">
                      <label for="end_date">終了年月日</label>
                      <div class="input-control" :class="msgError.regularly_reservation_end_date ? 'invalid ': ''">
                        <date-picker
                          v-model="dataSelected.regularly_reservation_end_date"
                          lang="ja"
                          placeholder="YYYY-MM-DD"
                          format="YYYY-MM-DD"
                          value-type="YYYY-MM-DD"
                          position="left"
                          :disabled-date="disabledDateForStartDate"
                          @blur="changeEndDate"
                        ></date-picker>
                        <span>{{msgError.regularly_reservation_end_date}}</span>
                      </div>
                    </div>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col sm="1" class="d-flex align-items-center">
                  <label class="col-form-label text-nowrap me-2">時間帯</label>
                </b-col>
                <b-col sm="11" class="d-flex align-items-center">
                  <div class="custom-radio-group">
                    <b-form-radio-group
                      class="radio-group"
                      id="works_periodically"
                      v-model="dataSelected.zz_day_of_time_zone_id"
                      name="day_of_time_zone"
                    >
                      <b-form-radio v-for="option in options_tables.zz_day_of_time_zones"
                                    :value="option.id">{{ option.day_of_time_zone }}
                      </b-form-radio>
                    </b-form-radio-group>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col sm="1" class="d-flex align-items-center">
                  <label class="col-form-label text-nowrap me-2">頻度</label>
                </b-col>
                <b-col sm="5" class="d-flex align-items-center">
                  <div class="custom-radio-group">
                    <b-form-radio-group
                      class="radio-group"
                      id="works_periodically"
                      v-model="dataSelected.zz_regularly_reservation_interval_id"
                      name="work-order-types-options"
                    >
                      <b-form-radio v-for="option in options_tables.zz_regularly_reservation_intervals"
                                    :value="option.id"
                                    disabled-field="notEnabled">{{ option.regularly_reservation_interval }}
                      </b-form-radio>
                    </b-form-radio-group>
                  </div>
                </b-col>
                <b-col sm="5" class="d-flex align-items-center">
                  <div class="input-control">
                    <div class="custom-input number-of-date gap-2">
                      <b-form-group v-slot="{ ariaDescribedby }">
                        <ValidationProvider
                          name="日"
                          :rules="isDateOfMonth ? 'required|min_value:1|max_value:31' : ''"
                          :custom-messages="{ required: '{_field_}は必須項目です', min_value:'{_field_}は{min}以上でなければなりません', max_value:'{_field_}は{max}以下でなければなりません'}"
                          v-slot="{ errors, classes }"
                        >
                          <div class="input-control" :class="classes">
                            <b-form-input
                              type="number"
                              class="d-flex gap-3"
                              v-model="dataSelected.regularly_reservation_date_of_month"
                              name="number-of-date"
                              :disabled="!isDateOfMonth"
                              :aria-describedby="ariaDescribedby"
                              min="1"
                            >
                            </b-form-input>
                            <span>{{ errors[0] }}</span>
                          </div>
                        </ValidationProvider>
                      </b-form-group>
                      <div class="align-self-center">日</div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col sm="1" class="d-flex align-items-center">
                  <label class="col-form-label text-nowrap me-2"></label>
                </b-col>
                <b-col sm="11" class="d-flex align-items-center">
                  <div class="custom-checkbox-core" style="margin-left: 30px;">
                    <b-form-group v-slot="{ ariaDescribedby }">
                      <ValidationProvider
                        :rules="isDateOfWeek ? 'required' : ''"
                        :custom-messages="{ required: '必須項目です' }"
                        v-slot="{ errors, classes }"
                      >
                        <div class="input-control" :class="classes">
                          <b-form-checkbox-group
                            :disabled="!isDateOfWeek"
                            id="checkbox-group-days-of-the-week"
                            class="d-flex gap-3"
                            v-model="dataSelected.regularly_reservation_day_of_week"
                            :options="days_of_the_week"
                            :aria-describedby="ariaDescribedby"
                            name="checkbox-group-days-of-the-week"
                          ></b-form-checkbox-group>
                          <span>{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
            </ValidationObserver>
          </b-overlay>
        </b-row>
        <div class="d-flex justify-content-end mt-4">
          <button
            @click="updateValue"
            class="btn btn-primary mr-5"
            :disabled="!checkValidate"
          >
            <i class='fas fa-check'></i> 確定
          </button>
        </div>
      </b-row>
    </b-modal>
  </div>
</template>
<style lang="scss">
.select-date {
  .split {
    font-size: 25px;
  }
}

.custom-datepicker label {
  align-self: unset;
}

.input-control.invalid span {
  white-space: nowrap;
}
.mr-5 {
  margin-right: 5px;
}
.reserve-calendar {
  td {
    height: 20px;
  }
}
</style>
